import { CopyActivity } from 'app/model/pipeline/copy.activity';
import {
    ICopySinkWithUpdateMethod,
    ICopySourceWithPartitionOption,
    IModel,
    Metamodel,
    ModelConstants,
    UpdateMethodType
} from 'shell-models-lib';
import { head } from 'lodash';
import { Model } from 'app/model/backendmodel';

export enum ReadMethod {
    SnapshotPlusIncremental = 'SnapshotPlusIncremental',
    Default = SnapshotPlusIncremental
}

export enum ChangeReadStrategy {
    Batch = 'Batch'
}

export enum NullWatermarkBehavior {
    Skip = 'Skip',
    IncludeOnFullLoad = 'IncludeOnFullLoad'
}

@Metamodel.model({
    name: ModelConstants.copyJobActivity,
    referable: true
})
export class CopyJobActivity extends CopyActivity {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ReadMethodLabel
    })
    public readMethod?: ReadMethod = ReadMethod.SnapshotPlusIncremental;

    @Metamodel.attribute({})
    public captureInstanceName?: string;

    @Metamodel.attribute({})
    public columns: Model.CopyJobIncrementalColumn[] = [];

    @Metamodel.attribute({
        display: stringResources.LowPrecisionMode
    })
    public lowPrecisionDatatypeMode?: boolean;
    
    @Metamodel.attribute({})
    public nullWatermarkBehavior?: NullWatermarkBehavior;

    /**
     * Controls how changes are read for this table. `Batch` copies the table in full
     * on every run and omits `changeDataSettings` for the source.
     */
    @Metamodel.attribute({})
    public changeReadStrategy?: ChangeReadStrategy;

    public isNativeCDCEnabled?: boolean;

    public get incrementalColumn(): (typeof this.columns)[number] {
        return head(this.columns);
    }

    public set incrementalColumn(column: (typeof this.columns)[number]) {
        this.columns = [column];
    }

    public get updateMethod(): UpdateMethodType {
        return (this.copySink as ICopySinkWithUpdateMethod)?.updateMethod;
    }

    public get partitionOption(): string {
        return (this.source as ICopySourceWithPartitionOption)?.partitionOption;
    }
}
